import type { SVGProps } from 'react'
const SvgSyMoreCircle = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillRule="evenodd"
			d="M12 2C6.486 2 2 6.487 2 12s4.486 10 10 10c5.513 0 10-4.487 10-10S17.513 2 12 2m0 1.5a8.49 8.49 0 0 1 8.5 8.5 8.49 8.49 0 0 1-8.5 8.5A8.49 8.49 0 0 1 3.5 12c0-4.703 3.796-8.5 8.5-8.5"
			clipRule="evenodd"
		/>
		<path
			d="M7.52 13.198a1.199 1.199 0 0 1 0-2.396 1.199 1.199 0 0 1 0 2.395m4.48.001a1.199 1.199 0 0 1 0-2.396 1.199 1.199 0 0 1 0 2.395m4.48.001a1.199 1.199 0 0 1 0-2.396 1.199 1.199 0 0 1 0 2.395"
			opacity={0.4}
		/>
	</svg>
)
export default SvgSyMoreCircle
